import dayjs from "dayjs";
import Litepicker from "litepicker";

(function () {
    "use strict";

    // Litepicker
    $(".datepicker_vac_req").each(function () {
        let options = {
            lang: 'de-DE',
            autoApply: true,
            singleMode: false,
            numberOfColumns: 2,
            numberOfMonths: 2,
            showWeekNumbers: true,
            format: "DD.MM.YYYY",
            dropdowns: {
                minYear: new Date().getFullYear(),
                maxYear: new Date().getFullYear() + 1,
                months: true,
                years: true,
            },
            tooltipText: {
                one: 'Tag',
                other: 'Tage'
            },
        };

        if (!$(this).val()) {
            let date = dayjs().format(options.format);
            date += !options.singleMode
                ? " - " + dayjs().add(1, "week").format(options.format)
                : "";
            $(this).val(date);
        }

        let picker = new Litepicker({
            element: this,
            ...options,
        });

        fetchJSON('/plan/api/vacation/my_dates')
            .then(function (data) {
                picker.setLockDays(data);
            })
    });

    function fetchJSON(url) {
        return fetch(url)
            .then(function (response) {
                return response.json();
            });
    }
})();
